import React from 'react'
import NoMealsImage from '../../../assets/img/noshipped-img.png'

const NoMeals = props => {
  const { mealsInDelivery } = props
  return (
    <div className="cookunity__no-selected-meals">
      <img src={NoMealsImage} alt="no meals" />
      <p className="title">No meals in here</p>
      {mealsInDelivery && (
        <p className="subtitle">
          Select <strong>{mealsInDelivery} meals</strong>
        </p>
      )}
    </div>
  )
}

export default NoMeals



// WEBPACK FOOTER //
// ./src/components/SelectedMeals/components/NoMeals.jsx